import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { Dispatch, SetStateAction, useState } from "react";
import { WebAppHandoverPendingOrderData } from "../../interface/red-ribbon";
import { APIDownloadCommercialHoldOrderDetails } from "../../service/api-service";
import { checkActionAuthorization, displayProjectClosingBalance, downloadCsvFile } from "../../service/shared.service";
import { OfficeTypeEnum } from "../../utils/enum";


function HandoverPendingOrderPaymentInfo(
    {
        handOverPendingOrderPaymentInfo,
        showDialogHandOverPendingInfo,
        setShowDialogHandOverPendingInfo,
        refundBtnCB,
        isActionDisabled = false
    }
        :
        {
            handOverPendingOrderPaymentInfo: WebAppHandoverPendingOrderData,
            showDialogHandOverPendingInfo: boolean,
            setShowDialogHandOverPendingInfo: Dispatch<SetStateAction<boolean>>,
            refundBtnCB: (csRefNumber: string, overDue: number) => void;
            isActionDisabled?: boolean;
        }
) {
    const [isDownloading, setIsDownloading] = useState(false);

    const downloadPaymentDetails = async () => {
        try {
            setIsDownloading(true);

            const response = await APIDownloadCommercialHoldOrderDetails(
                handOverPendingOrderPaymentInfo._id
            );

            const pdfUrl = response.data.data.pdfUrl;

            if (!pdfUrl) {
                console.error("PDF URL not found");
                return;
            }
            const fileName = pdfUrl.split("/").pop() || "payment-details.pdf";
            await downloadCsvFile(pdfUrl, fileName);

        } catch (error) {
            console.error("Download failed", error);
        } finally {
            setIsDownloading(false);
        }
    };
    return (
        <>
            <Dialog header={<>View Payment Info <strong>#{handOverPendingOrderPaymentInfo.csRefNumber}</strong></>}
                visible={showDialogHandOverPendingInfo} style={{ width: '35vw' }}
                draggable={false} resizable={false} modal={true} blockScroll={true}
                onHide={() => { if (!showDialogHandOverPendingInfo) return; setShowDialogHandOverPendingInfo(false); }}>
                <div className="row">

                    <div className="col-md-4 mb-3">
                        <span>Grand Total</span>
                        <p>
                            <strong>{handOverPendingOrderPaymentInfo.grandTotal}</strong>
                        </p>
                    </div>

                    {
                        Number(handOverPendingOrderPaymentInfo.discountPerc) > 0 &&
                        <div className="col-md-4 mb-3">
                            <span>Order Discount</span>
                            <p>
                                <strong>{handOverPendingOrderPaymentInfo.discountPerc}%</strong>
                            </p>
                        </div>
                    }

                    <div className="col-md-4 mb-3">
                        <span>Order Final AMT</span>
                        <p>
                            <strong>{handOverPendingOrderPaymentInfo.finalAmount}</strong>
                        </p>
                    </div>

                    <div className="col-md-4 mb-3">
                        <span>Dealer Discount</span>
                        <p>
                            <strong>
                                {
                                    parseFloat(
                                        String(handOverPendingOrderPaymentInfo.grandTotal * (handOverPendingOrderPaymentInfo.dealerDiscount / 100))
                                    ).toFixed(0)
                                }
                                ({handOverPendingOrderPaymentInfo.dealerDiscount})%</strong>
                        </p>
                    </div>

                    <div className="col-md-4 mb-3">
                        <span>Dealer Price</span>
                        <p>
                            <strong>
                                {handOverPendingOrderPaymentInfo.dealerPrice}
                            </strong>
                        </p>
                    </div>

                    {
                        Number(handOverPendingOrderPaymentInfo.collection) > 0 &&
                        <div className="col-md-4 mb-3">
                            <span>Opening Balance</span>
                            <p>
                                <strong>{handOverPendingOrderPaymentInfo.collection}</strong>
                            </p>
                        </div>
                    }

                    {
                        handOverPendingOrderPaymentInfo.officeType === OfficeTypeEnum.DEALEROFFICE &&
                        <div className="col-md-4 mb-3">
                            <span>Webapp Collection</span>
                            <p>
                                <strong>{handOverPendingOrderPaymentInfo.eazyPaySuccessAndSettleaAmount}</strong>
                            </p>
                        </div>
                    }

                    {
                        handOverPendingOrderPaymentInfo.officeType === OfficeTypeEnum.JBOFFICE &&
                        <>
                            <div className="col-md-4 mb-3">
                                <span>Invoice Collection</span>
                                <p>
                                    <strong>{handOverPendingOrderPaymentInfo.INVOICECOLLECTION}</strong>
                                </p>
                            </div>
                            <div className="col-md-4 mb-3">
                                <span>PDC Collection</span>
                                <p>
                                    <strong>{handOverPendingOrderPaymentInfo.PDCCollection}</strong>
                                </p>
                            </div>
                        </>
                    }

                    {
                        Number(handOverPendingOrderPaymentInfo.refunds) > 0 &&
                        <div className="col-md-4 mb-3">
                            <span>Refunds</span>
                            <p>
                                <strong>{handOverPendingOrderPaymentInfo.refunds}</strong>
                            </p>
                        </div>
                    }

                    {
                        Number(handOverPendingOrderPaymentInfo.additionalDealerDiscountValue) > 0 &&
                        <div className="col-md-4 mb-3">
                            <span>Additional Dealer Discount</span>
                            <p>
                                <strong>{handOverPendingOrderPaymentInfo.additionalDealerDiscountValue}</strong>
                            </p>
                        </div>
                    }

                    {
                        Number(handOverPendingOrderPaymentInfo.write_off) > 0 &&
                        <div className="col-md-4 mb-3">
                            <span>Write Off</span>
                            <p>
                                <strong>{handOverPendingOrderPaymentInfo.write_off}</strong>
                            </p>
                        </div>
                    }

                    {
                        Number(handOverPendingOrderPaymentInfo.openingSales) > 0 &&
                        <div className="col-md-4 mb-3">
                            <span>Opening Sales</span>
                            <p>
                                <strong>{handOverPendingOrderPaymentInfo.openingSales}</strong>
                            </p>
                        </div>
                    }

                    {
                        Number(handOverPendingOrderPaymentInfo.webappSales) > 0 &&
                        <div className="col-md-4 mb-3">
                            <span>Webapp Sales</span>
                            <p>
                                <strong>{handOverPendingOrderPaymentInfo.webappSales}</strong>
                            </p>
                        </div>
                    }

                    {
                        Number(handOverPendingOrderPaymentInfo.extraWorkOrdersAMT) > 0 &&
                        <div className="col-md-4 mb-3">
                            <span>Extra Order Amount</span>
                            <p>
                                <strong>{handOverPendingOrderPaymentInfo.extraWorkOrdersAMT}</strong>
                            </p>
                        </div>
                    }

                    {
                        Number(handOverPendingOrderPaymentInfo.creditNotes) > 0 &&
                        <div className="col-md-4 mb-3">
                            <span>Credit Notes</span>
                            <p>
                                <strong>{handOverPendingOrderPaymentInfo.creditNotes}</strong>
                            </p>
                        </div>
                    }

                    {
                        handOverPendingOrderPaymentInfo.officeType === OfficeTypeEnum.JBOFFICE &&
                        <>
                            <div className="col-md-4 mb-3">
                                <span>Due</span>
                                <p>
                                    <strong>{handOverPendingOrderPaymentInfo.due}</strong>
                                </p>
                            </div>

                            <div className="col-md-4 mb-3">
                                <span>Over Due</span>
                                <p>
                                    <strong>{handOverPendingOrderPaymentInfo.overDue}</strong>
                                </p>
                            </div>
                        </>
                    }

                    {
                        handOverPendingOrderPaymentInfo.officeType === OfficeTypeEnum.DEALEROFFICE &&
                        <>
                            <Divider />

                            <div className="row mt-2">

                                {
                                    Number(handOverPendingOrderPaymentInfo.netSales) !== 0 &&
                                    <div className="col-md-4 mb-3">
                                        <span>Net Sales</span>
                                        <p>
                                            <strong>{handOverPendingOrderPaymentInfo.netSales}</strong>
                                        </p>
                                    </div>
                                }

                                {
                                    Number(handOverPendingOrderPaymentInfo.netCollection) !== 0 &&
                                    <div className="col-md-4 mb-3">
                                        <span>Net Collection</span>
                                        <p>
                                            <strong>{handOverPendingOrderPaymentInfo.netCollection}</strong>
                                        </p>
                                    </div>
                                }

                                {
                                    Number(handOverPendingOrderPaymentInfo.projectLedgerBalance) !== 0 &&
                                    <div className="col-md-4 mb-3">
                                        <span>Project Ledger Balance</span>
                                        <p>
                                            <strong>{displayProjectClosingBalance(handOverPendingOrderPaymentInfo.projectLedgerBalance)}</strong>
                                        </p>
                                    </div>
                                }

                            </div>
                        </>
                    }

                </div>
                <div className="col-12 d-flex justify-content-end gap-2">
                    <button
                        className="btn btn-success"
                        type="button"
                        onClick={downloadPaymentDetails}
                        disabled={isDownloading}
                        style={{ borderRadius: "5px", minWidth: "120px" }}
                    >
                        {isDownloading ? "Downloading..." : "Download"}
                    </button>
                    {
                        (
                            checkActionAuthorization("upgrade", "Access to refund payment")
                            && handOverPendingOrderPaymentInfo.officeType === OfficeTypeEnum.DEALEROFFICE && (!isActionDisabled)
                        ) &&
                        <button className="btn btn-success" type="button"
                            onClick={() => refundBtnCB(handOverPendingOrderPaymentInfo.csRefNumber, Math.abs(handOverPendingOrderPaymentInfo.overDue))}
                            style={{ borderRadius: '5px' }}>
                            Refund
                        </button>
                    }
                </div>
            </Dialog >
        </>
    )
}

export default HandoverPendingOrderPaymentInfo;